import { render, staticRenderFns } from "./isActiveDishModal.vue?vue&type=template&id=15316c96&scoped=true"
import script from "./isActiveDishModal.vue?vue&type=script&lang=js"
export * from "./isActiveDishModal.vue?vue&type=script&lang=js"
import style0 from "./isActiveDishModal.vue?vue&type=style&index=0&id=15316c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15316c96",
  null
  
)

export default component.exports